// extracted by mini-css-extract-plugin
module.exports = {"center":"RecoveryEntry-RecoveryEntry-center-05380165","displayBlock":"RecoveryEntry-RecoveryEntry-displayBlock-55e2f2aa"};